import React, { Component } from "react";
import axios from "axios";
require("es6-promise").polyfill();

import wideFactory from "../../../media/icons/wideFactory.svg";

import styles from "./ContactForm.module.scss";
import { Icon } from "@material-ui/core";

class ContactForm extends Component {
  state: {
    name: string;
    email: string;
    subject: string;
    message: string;
    sending: boolean;
    highlightInvalid: boolean;
    messageSent: boolean;
    error: string | undefined;
  };

  constructor(props: {}) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
      sending: false,
      highlightInvalid: false,
      messageSent: false,
      error: undefined
    };
  }

  handleForm(e: any) {
    e.preventDefault();

    if (
      this.state.name === "" ||
      this.state.email == "" ||
      this.state.subject == ""
    ) {
      this.setState({ highlightInvalid: true });
      return;
    } else {
      this.setState({ highlightInvalid: false });
    }

    this.setState({ sending: true, error: undefined });

    axios({
      method: "post",
      url: "./email.php",
      headers: { "Content-Type": "application/json" },
      data: this.state
    })
      .then((response: any) => {
        this.setState({ sending: false });
        this.setState({ messageSent: response.data.sent });
      })
      .catch(e => {
        this.setState({ sending: false, error: e.message });
      });
  }

  render() {
    return (
      <div id={styles.formPageSection}>
        <div id={styles.formContainer}>
          <span id={styles.formTitle}>Manufacturing Inquiries</span>
          <form action="/email_handler.php" id={styles.form}>
            <input
              className={`${styles.formInput} ${
                this.state.highlightInvalid && this.state.name == ""
                  ? styles.invalid
                  : undefined
              } ${this.state.messageSent ? styles.sent : undefined}`}
              id={styles.formName}
              type="text"
              name="name"
              placeholder="Your name"
              value={this.state.name}
              onChange={e => this.setState({ name: e.target.value })}
              disabled={this.state.messageSent ? true : false}
            />
            <input
              className={`${styles.formInput} ${
                this.state.highlightInvalid && this.state.email == ""
                  ? styles.invalid
                  : undefined
              } ${this.state.messageSent ? styles.sent : undefined}`}
              id={styles.formEmail}
              type="text"
              name="email"
              placeholder="Your e-mail"
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
              disabled={this.state.messageSent ? true : false}
            />
            <input
              className={`${styles.formInput} ${
                this.state.highlightInvalid && this.state.subject == ""
                  ? styles.invalid
                  : undefined
              } ${this.state.messageSent ? styles.sent : undefined}`}
              id={styles.formSubject}
              type="text"
              name="subject"
              placeholder="Subject"
              value={this.state.subject}
              onChange={e => this.setState({ subject: e.target.value })}
              disabled={this.state.messageSent ? true : false}
            />
            <textarea
              className={`${styles.formInput} ${
                this.state.messageSent ? styles.sent : undefined
              }`}
              id={styles.formMessage}
              name="message"
              placeholder="Message"
              value={this.state.message}
              onChange={e => this.setState({ message: e.target.value })}
              disabled={this.state.messageSent ? true : false}
            />
            <div id={styles.submitContainer}>
              <div id={styles.submitButton} onClick={e => this.handleForm(e)}>
                {this.icon()}
                <div
                  className={
                    this.state.messageSent
                      ? styles.textSent
                      : styles.textNotSent
                  }
                  id={styles.submitText}
                >
                  {this.state.messageSent ? "inquiry Sent" : "Send Inquiry"}
                </div>
              </div>
              <Icon
                className={`${styles.hidden} ${
                  this.state.sending ? styles.sending : undefined
                }`}
              >
                autorenew
              </Icon>
              <div id={styles.error}>
                {this.state.error && "Something went wrong, please try again"}
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  icon() {
    return (
      <svg
        viewBox="25 80 130 90"
        id={styles.factoryIcon}
        className={
          this.state.messageSent ? styles.iconSent : styles.iconNotSent
        }
      >
        <g>
          <rect width="132.7036" height="51.31575" x="25.358999" y="117" />
          <rect
            width="18.013781"
            height="21.457649"
            x="140.04881"
            y="96.480568"
          />

          <rect
            width="18.097162"
            height="3.7102621"
            x="140.04881"
            y="90.45121"
          />
          <rect
            width="18.097162"
            height="7.4833083"
            x="140.04881"
            y="81.015274"
          />
          <rect
            width="118.6529"
            height="5.8245845"
            x="26.347101"
            y="117.39487"
          />
          <path d="M 140.04925,117.5558 H 111.40849 V 97.08239" />
          <path d="M 111.40849,117.5558 H 82.767735 V 97.08239" />
          <path d="M 82.640754,117.5558 H 54 V 97.08239" />
          <path d="M 54,117.5558 H 25.359246 V 97.082394" />
        </g>
      </svg>
    );
  }
}

export default ContactForm;
